import React, { useState, useRef, useCallback } from 'react';
import { func, shape } from 'prop-types';

import Avatar from 'Shared/components/Avatar/Avatar';
import { convertFileToBase64 } from 'Shared/helpers';
import { acceptedProfilePictureFormats } from 'Shared/constants/constants';

import './AvatarChangePic.scss';

const defaultAvatar = { color: '#65A3A7', initials: 'D' };

function AvatarChangePic({ avatar, setAvatarPic }) {
  const [previewAvatar, setPreviewAvatar] = useState(null);

  const fileUploader = useRef();

  const handleChangePic = useCallback(
    async event => {
      const file = event.target.files[0];
      const url = await convertFileToBase64(file);
      setPreviewAvatar(url);
      setAvatarPic(file);
    },
    [setAvatarPic]
  );

  const handleFileUploadClick = useCallback(() => fileUploader.current.click(), [fileUploader]);

  return (
    <>
      <input
        style={{ display: 'none' }}
        type="file"
        accept={acceptedProfilePictureFormats}
        name="avatar"
        ref={fileUploader}
        onChange={handleChangePic}
      />
      <div className="d-flex">
        {!previewAvatar ? (
          <Avatar height={50} avatar={avatar || defaultAvatar} initialsNotSmallSize />
        ) : (
          <div className="avatar-circle avatar-preview" style={{ backgroundImage: `url(${previewAvatar})` }} />
        )}
        <div className="avatar-change-field ml-2 align-self-center" onClick={handleFileUploadClick}>
          Change pic
        </div>
      </div>
    </>
  );
}

AvatarChangePic.propTypes = {
  avatar: shape({}).isRequired,
  setAvatarPic: func.isRequired,
};

export default AvatarChangePic;
